export const DEFAULT_AUCTION_URL = 'invaluableauctions.com/al/landing.cfm';
